import { render, staticRenderFns } from "./PerfilTurma.vue?vue&type=template&id=2a0e0383&"
import script from "./PerfilTurma.vue?vue&type=script&lang=js&"
export * from "./PerfilTurma.vue?vue&type=script&lang=js&"
import style0 from "./PerfilTurma.vue?vue&type=style&index=0&id=2a0e0383&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports